import React from "react";
import CPF from "./CPF";
import CNPJ from "./CNPJ";
import IE from "./IE";

const Id = ({ value, warn, empty }) => {
  const id = (value || "").replace(/[^\d]/g, "");

  if (id.length === 0) return empty || "";

  if (id.length === 11) return <CPF value={value} warn={warn} empty={empty} />;

  if (id.length === 14) return <CNPJ value={value} warn={warn} empty={empty} />;

  if (id.length === 9) return <IE value={value} warn={warn} empty={empty} />;

  return warn ? "Inválido" : id;
};

export default Id;
